import React from 'react';

/**
 * Wrapper для удаленных Module Federation компонентов
 * Обеспечивает совместимость версий React
 */
export const RemoteComponentWrapper = ({ children, ...props }) => {
  // Форсируем использование хост-версии React
  if (typeof window !== 'undefined') {
    window.React = React;
    window.__REACT__ = React;
  }

  return React.createElement(
    'div',
    {
      ...props,
      'data-mf-wrapper': 'true',
      style: {
        minHeight: '100vh',
        width: '100%',
        ...props.style,
      },
    },
    children
  );
};

export default RemoteComponentWrapper;
